import React from 'react';
import PropTypes from 'prop-types';

import classnames from '../util/classnames';

function WaitButton({ children, className, type = 'button', wait: waiting, ...props }) {
  return (
    <button className={classnames(className, { waiting })} disabled={waiting} type={type} {...props}>
      {children}
    </button>
  );
}

WaitButton.propTypes = {
  autoFocus: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
  ref: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.object
  ]),
  type: PropTypes.oneOf(['button', 'submit']),
  wait: PropTypes.bool
};

export default WaitButton;
